export default {
  white: "#ffffff",
  black: "#2C2C2C",
  zuccini: "#05341A",
  rainforrest: "#006B55",
  caribbean: "#00D0A6",
}
